<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name" #title>関連会社一覧</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="element-column">
          <div class="column-list">
            <label class="list-input-title">関連会社区分</label>
            <div class="list-input-content">
              <app-radio-label [(ngModel)]="kymw9010Model.associatedCompanyType" label="制作会社" value="1" [disabled]="true"
                name="grp_associatedCompanyType">
              </app-radio-label>
              <app-radio-label [(ngModel)]="kymw9010Model.associatedCompanyType" label="スタジオ" value="2" [disabled]="true"
                name="grp_associatedCompanyType">
              </app-radio-label>
            </div>
          </div>
          <div>
            <wj-flex-grid id="dgt_associatedCompanyList" #dgt_associatedCompanyList
              [itemsSource]="kymw9010Model.associatedCompanyList" [allowDragging]="'None'" selectable="true"
              horizontalScrollPolicy="on" [isReadOnly]="true" forcedEnabledMode="true" [tabindex]="0"
              [headersVisibility]="'Column'" [selectionMode]="'Row'"
              [allowSorting]="false">
              <wj-flex-grid-filter #fltr_associatedCompanyList></wj-flex-grid-filter>
              <wj-flex-grid-column [minWidth]="5" [width]="420" [header]="'関連会社名'" [binding]="'associatedCompanyName'"></wj-flex-grid-column>
              <wj-flex-grid-filter #fltr_tradeStopDivNameList></wj-flex-grid-filter>
              <wj-flex-grid-column [minWidth]="5" [width]="115" [header]="'取引停止区分'" [binding]="'tradeStopDivName'"></wj-flex-grid-column>
            </wj-flex-grid>
          </div>
        </div>
      </div>
    </td>
  </tr>
  
  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button class="btn-primary" [tabindex]="0" (click)="eventRegistUser_CLICKHandler()">設定</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickWindowClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>